// Module
var code = "<inquiry-detail-page\n  inquiry-id=\"$resolve.inquiryId\"\n  variant-id=\"$resolve.variantId\"\n></inquiry-detail-page>\n";
// Exports
module.exports = code;